import { useEffect, useState } from 'react'
import './Anketa.css'
import './About.css'
import { log } from '../../utils/logger'

interface AboutPageConfig {
  title?: string
  paragraphs?: string[]
  /** Текст до ссылки на тарифы, например: «Актуальные данные по тарифам находятся» */
  tariffsLine?: string
  tariffsLinkLabel?: string
  tariffsLinkHref?: string
  contactsHeading?: string
  socialLinks?: { label: string; href: string }[]
  phones?: string[]
}

export const About = () => {
  const [config, setConfig] = useState<AboutPageConfig | null>(null)

  useEffect(() => {
    fetch('/config.json')
      .then((res) => res.json())
      .then((c) => {
        const ap = c['about-page']
        if (ap && typeof ap === 'object') {
          setConfig(ap as AboutPageConfig)
        }
        log('About', 'Загружен about-page из config')
      })
      .catch((err) => {
        log('About', 'Ошибка загрузки config', err)
        setConfig({ title: 'О нас', paragraphs: [] })
      })
  }, [])

  if (!config) {
    return (
      <div className="anketa-container about-page">
        <div className="anketa-card">
          <p className="about-loading">Загрузка…</p>
        </div>
      </div>
    )
  }

  const title = config.title || 'О нас'

  return (
    <div className="anketa-container about-page">
      <div className="anketa-card about-card">
        <div className="question-section">
          <h1 className="question-text about-title">{title}</h1>
        </div>

        <div className="about-body">
          {(config.paragraphs || []).map((p, i) => (
            <p key={i} className="about-paragraph">
              {p}
            </p>
          ))}

          {(config.tariffsLine || config.tariffsLinkHref) && (
            <p className="about-paragraph about-tariffs-line">
              {config.tariffsLine?.trim() || 'Актуальные данные по тарифам находятся'}
              {config.tariffsLinkHref ? (
                <>
                  {' '}
                  <a href={config.tariffsLinkHref} target="_blank" rel="noreferrer" className="about-inline-link">
                    {config.tariffsLinkLabel || 'ЗДЕСЬ'}
                  </a>
                  .
                </>
              ) : (
                '.'
              )}
            </p>
          )}

          {config.contactsHeading && <h2 className="about-subheading">{config.contactsHeading}</h2>}

          {config.socialLinks && config.socialLinks.length > 0 && (
            <ul className="about-links">
              {config.socialLinks.map((item, i) => (
                <li key={i}>
                  <span className="about-link-label">{item.label}</span>{' '}
                  <a href={item.href} target="_blank" rel="noreferrer" className="about-inline-link">
                    {item.href}
                  </a>
                </li>
              ))}
            </ul>
          )}

          {config.phones && config.phones.length > 0 && (
            <ul className="about-phones">
              {config.phones.map((phone, i) => (
                <li key={i}>
                  <a href={`tel:${phone.replace(/\s/g, '')}`} className="about-phone-link">
                    {phone}
                  </a>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  )
}
